import palette from "./palette";
import common from "./common.js";

// day theme
const styles = {
  ...common.styles,
  palette: {
    ...common.styles.palette,
    primary: {
      main: palette.black,
    },
    secondary: {
      main: palette.grey,
    },
    mode: "light",
    background: {
      default: palette.white,
      rgb: palette.white_rgb,
      contrast: palette.dark_grey,
    }
  },
  components: {
    ...common.styles.components,
    MuiBackdrop: {
      styleOverrides: {
        root: { background: `${palette.white}CC` },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { background: palette.white },
      },
    },
  },
};

const image_dir = "./day";

const day = { styles, image_dir };

export default day;
